import { createContext, useContext, useState, useCallback, useEffect } from 'react';
import * as api from '../services/api';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [agent, setAgent] = useState(() => {
    try {
      const saved = localStorage.getItem('agent');
      return saved ? JSON.parse(saved) : null;
    } catch { return null; }
  });

  const login = useCallback(async (email, password) => {
    const data = await api.login(email, password);
    localStorage.setItem('token', data.token);
    localStorage.setItem('agent', JSON.stringify(data.agent));
    setAgent(data.agent);
    return data.agent;
  }, []);

  const logout = useCallback(() => {
    localStorage.removeItem('token');
    localStorage.removeItem('agent');
    setAgent(null);
  }, []);

  // Refresh agent data from DB on mount — syncs role/name changes without re-login
  // 401 response (agent deleted / token expired) → auto-logout via api.js handler
  useEffect(() => {
    if (!localStorage.getItem('token')) return;
    api.getMe()
      .then(data => {
        if (!data?.agent) return;
        const next = JSON.stringify(data.agent);
        if (next !== localStorage.getItem('agent')) {
          localStorage.setItem('agent', next);
          setAgent(data.agent);
        }
      })
      .catch(() => {}); // 401 handled by request() → auto-logout+reload
  }, []);

  return (
    <AuthContext.Provider value={{ agent, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
